import { getPlatformTag, PlatformTag, SupportedCompanies, SupportedTags } from '@apparel/core/platform';

type Module = null | ((any) => any);

export function createPlatformView(from: Partial<Record<PlatformTag | 'default', Module>>) {
    const tag = getPlatformTag();
    const view = from[tag] || from.default || from[SupportedTags.APPAREL_ORDER] || from[SupportedCompanies.APPAREL];
    return (view as any)?.default || view;
}
